import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to guess which conflict group a `text-*` class belongs to.
 * Our display scale (`text-display-md`, `text-rail`) is neither a stock size nor a
 * known colour, so out of the box it lands in the same group as `text-bone` and the
 * later colour silently wins — headings then render at the base size. Declaring the
 * custom font-size keys puts them back in the font-size group where they belong.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["display-xl", "display-lg", "display-md", "rail"] }],
    },
  },
});

/** Merge conditional class names, de-duping Tailwind conflicts. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
